var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{attrs:{"allowEmpty":false,"options":_vm.options,"track-by":"value","label":"text","placeholder":"Select one","selectLabel":"","selectedLabel":"","deselectLabel":"","searchable":true},on:{"input":_vm.countrySelected},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed58c58a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./prompts/components/CountrySelect.vue
// module id = null
// module chunks = 